import { Component, HostListener, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LotDetailContext } from './lot-detail.context';
import { JhiEventManager, JhiLanguageService } from '../../shared/core-utils';
import { ActivatedRoute, Router } from '@angular/router';
import { FileService } from '../../shared/file/service/file.service';
import { LotService } from '../../shared/inventory/service/lot.service';
import { Lot } from '../../shared/inventory/model/lot.model';

@Component({
    selector: 'jhi-lot-detail-dialog',
    templateUrl: './lot-detail-main.component.html'
})
export class LotDetailMainComponent implements OnInit {

    lot: Lot;
    hasChanges = false;
    lotUUID: string;
    isFileStorageConfigured: boolean;
    initialTab: string;

    @HostListener('window:message', ['$event'])
    onMessage(event) {
        if (event.data === 'lot-details-changed') {
            this.hasChanges = true;
            this.loadLot();
        }
    }

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private router: Router,
        private route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private lotService: LotService,
        private lotDetailContext: LotDetailContext,
        private fileService: FileService
    ) {
        this.lotUUID = this.route.snapshot.paramMap.get('lotUUID');
        this.lotDetailContext.lotUUID = this.lotUUID;
    }

    ngOnInit(): void {
        this.loadLot();
        this.fileService.isFileStorageConfigured().then((isFileStorageConfigured) => this.isFileStorageConfigured = isFileStorageConfigured);
    }

    clear() {
        this.eventManager.broadcast({ name: 'hasAttributeChange', content: 'OK' });
        this.activeModal.dismiss('cancel');
    }

    loadLot(): void {
        this.lotService.getById(this.lotDetailContext.lotUUID).then((lot) => {
            this.lot = lot;
            if (lot) {
                this.lotDetailContext.lotId = lot.lotId;
                this.initialTab = this.route.snapshot.paramMap.get('initialTab') || 'lot-basic-details';
                this.navigateToTab(lot.lotUUID, this.initialTab);
            }
        });
    }

    navigateToTab(lotUUID: string, route: string) {
        this.router.navigate([{
            outlets: {
                'lotDetailPopup': ['lot-detail-main', lotUUID, {
                    outlets: {
                        'lot-detail-outlet': [route]
                    }
                }]
            }
        }], { queryParamsHandling: 'preserve' });
    }
}
